<template>
  <div>
    <h3 class="mb-5 text-center">Customer Purchase History</h3>
    <vs-table :data="lastRecord" class="invoice__product__details vs-con-loading__container">
      <template slot="thead">
        <vs-th>Date</vs-th>
        <vs-th>Invoice Number #</vs-th>
        <vs-th>Item Name</vs-th>
        <vs-th>Total </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <!--Date  -->
          <vs-td>
            {{ formatDate(tr.sales_item_date) }}
          </vs-td>

          <!-- invoice number -->
          <vs-td>
            {{ tr.sales && tr.sales.sales_code }}
          </vs-td>

          <!-- Item Name -->
          <vs-td class="product_name" :data="tr.product_name">
            {{ tr.product_name }}
          </vs-td>

          <!-- total  -->
          <vs-td> $ {{ tr.grand_amt | priceFilter }} </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { weightMixins } from '@/utils/weightType'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'customerLastPOS',
  props: {
    lastRecord: Array
  },

  mixins: [dateMixins],

  data() {
    return {
      customer: null
    }
  },
  filters: {
    weightFilter(val) {
      return weightMixins.methods.mathRound(val, 3)
    },
    priceFilter(val) {
      return weightMixins.methods.mathRound(val, 2)
    }
  }
}
</script>

<style scoped lang="scss">
.customer__details {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
</style>